export * from './Icon';
import Icon from './Icon';
export default Icon;
